export enum CourseFormat {
  Online = "e-learning",
  Classroom = "classroom",
  Blended = "blended"
}

export const courseFormatOrder: string[] = [
  CourseFormat.Classroom,
  CourseFormat.Blended,
  CourseFormat.Online
];
